export default __webpack_public_path__ + "static/media/bannerImage2.5e3364e0.png";